import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HouseLine, ArrowLeft } from '@phosphor-icons/react';

const TopNav = ({ title, showBack = true, showHome = true, className = '' }) => {
  const navigate = useNavigate();

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {showBack && (
        <button
          onClick={() => navigate(-1)}
          className="p-2 hover:bg-slate-100 rounded-full transition-colors"
          data-testid="nav-back-btn"
          title="Go back"
        >
          <ArrowLeft size={22} className="text-slate-700" />
        </button>
      )}
      {showHome && (
        <button
          onClick={() => navigate('/')}
          className="p-2 hover:bg-slate-100 rounded-full transition-colors"
          data-testid="nav-home-btn"
          title="Go to home"
        >
          <HouseLine size={22} className="text-slate-700" />
        </button>
      )}
      {title && (
        <h1 className="font-semibold text-slate-900 ml-1 truncate">{title}</h1>
      )}
    </div>
  );
};

export default TopNav;
